import { Component, ErrorInfo, ReactNode } from 'react';
import GeneralError from './GeneralError';
import { EventEmitter, Events } from '../../ExpressCheckout/types';

type ErrorBoundaryProps = {
  children: ReactNode;
  onError?: EventEmitter;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error(error, errorInfo);
    // eslint-disable-next-line react/prop-types
    if(this.props.onError) {
      // eslint-disable-next-line react/prop-types
      this.props.onError(Events.ERROR, error.toString());
    }
    this.setState({ error });
  }

  render(): ReactNode {
    const { error, hasError } = this.state;

    if (hasError) {
      return <GeneralError error={error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
